import { Platform } from 'react-native';

export default function testID(id: string): TestIDProps {
  return Platform.OS === 'android'
    ? { accessible: true, accessibilityLabel: id }
    : { accessible: false, testID: id };
}

export interface TestIDProps {
  accessible?: boolean;
  accessibilityLabel?: string;
  testID?: string;
}
